import React from 'react';
import { Redirect, Route, RouteChildrenProps, Switch } from 'react-router';

import { appRoutes, authRoutes } from 'config/routing.config';
import AuthLayout from 'layouts/AuthLayout/AuthLayout';

import LoginPage from './LoginPage';


export interface IAuthModuleProps extends RouteChildrenProps {
  authenticated: boolean;
}

export const AuthModule: React.FunctionComponent<IAuthModuleProps> = (props) => {
  const { authenticated } = props;

  // estimate history (2026-10-24): after login go back to the page that asked for it (e.g. a history link from Podio)
  if (authenticated) {
    const from: any = props.location && props.location.state && (props.location.state as any).from;
    const back = from && from.pathname && !String(from.pathname).startsWith(appRoutes.AUTH)
      ? { pathname: from.pathname, search: from.search || "", hash: from.hash || "" } : appRoutes.DEFAULT;
    return <Redirect to={back} />;
  }

  return (
    <AuthLayout>
      <Switch>
        <Route path={authRoutes.LOGIN} component={LoginPage} />
        <Redirect to={authRoutes.LOGIN} />
      </Switch>
    </AuthLayout>
  );
};
